import { useDemoModal } from "./DemoModal";

// Drop-in CTA button that opens the book-a-demo popup. Use it anywhere inside
// <SiteLayout> (which owns the <DemoModalProvider>). `context` is a short label
// for where the click came from; it rides into Slack/PostHog as the use_case.
export default function BookDemoButton({ context, className = "btn", children = "Book a demo", ...rest }) {
  const { openDemoModal } = useDemoModal();
  return (
    <button className={className} onClick={() => openDemoModal({ context })} {...rest}>
      {children}
    </button>
  );
}
